var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCoolBlueFrame(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 126,
    height: 118,
    viewBox: "0 0 126 118",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_938_140)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ii_938_140)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.33521 42.2883C3.33521 37.3762 7.31724 33.3942 12.2293 33.3942H83.3823C88.2943 33.3942 92.2764 37.3762 92.2764 42.2883V101.582C92.2764 106.494 88.2944 110.477 83.3823 110.477H12.2293C7.31724 110.477 3.33521 106.494 3.33521 101.582V42.2883Z",
    fill: "#3698AD"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M3.33521 42.2883C3.33521 37.3762 7.31724 33.3942 12.2293 33.3942H83.3823C88.2943 33.3942 92.2764 37.3762 92.2764 42.2883V101.582C92.2764 106.494 88.2944 110.477 83.3823 110.477H12.2293C7.31724 110.477 3.33521 106.494 3.33521 101.582V42.2883Z",
    stroke: "#292D32",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_938_140)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.394 57.3942C40.394 44.1393 51.1392 33.3942 64.394 33.3942H99.4058C112.661 33.3942 123.406 44.1393 123.406 57.3942V86.4765C123.406 99.7313 112.661 110.477 99.4058 110.477H64.3941C51.1392 110.477 40.394 99.7314 40.394 86.4765V57.3942Z",
    fill: "#43CDEC"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M40.394 57.3942C40.394 44.1393 51.1392 33.3942 64.394 33.3942H99.4058C112.661 33.3942 123.406 44.1393 123.406 57.3942V86.4765C123.406 99.7313 112.661 110.477 99.4058 110.477H64.3941C51.1392 110.477 40.394 99.7314 40.394 86.4765V57.3942Z",
    stroke: "#292D32",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.8294 34.8765H101.912L81.1588 108.994H67.0764L87.8294 34.8765Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.2705 34.8765H84.494L63.7411 108.994H61.5176L82.2705 34.8765Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_ii_938_140)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78.9353 86.9865C78.9353 86.5903 79.2469 86.2642 79.6426 86.2461L108.178 84.9413C108.6 84.922 108.953 85.2591 108.953 85.6817V93.4294C108.953 93.8388 108.621 94.1706 108.212 94.1706H79.6765C79.2671 94.1706 78.9353 93.8388 78.9353 93.4294V86.9865Z",
    fill: "#FF9D43"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M78.9353 86.9865C78.9353 86.5903 79.2469 86.2642 79.6426 86.2461L108.178 84.9413C108.6 84.922 108.953 85.2591 108.953 85.6817V93.4294C108.953 93.8388 108.621 94.1706 108.212 94.1706H79.6765C79.2671 94.1706 78.9353 93.8388 78.9353 93.4294V86.9865Z",
    stroke: "#292D32",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_ii_938_140)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117.477 76.3823H101.912V94.1706H117.086C117.093 94.1706 117.099 94.1706 117.106 94.1706C117.112 94.1706 117.119 94.1706 117.126 94.1706H117.477V94.1597C121.398 93.9279 124.518 90.0394 124.518 85.2765C124.518 80.5135 121.398 76.625 117.477 76.3933V76.3823Z",
    fill: "#FF9D43"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M101.912 76.3823V75.3823C101.36 75.3823 100.912 75.83 100.912 76.3823H101.912ZM117.477 76.3823H118.477C118.477 75.83 118.029 75.3823 117.477 75.3823V76.3823ZM101.912 94.1706H100.912C100.912 94.7228 101.36 95.1706 101.912 95.1706V94.1706ZM117.086 94.1706L117.089 93.1706H117.086V94.1706ZM117.126 94.1706V93.1706L117.122 93.1706L117.126 94.1706ZM117.477 94.1706V95.1706C118.029 95.1706 118.477 94.7228 118.477 94.1706H117.477ZM117.477 94.1597L117.418 93.1614C116.889 93.1926 116.477 93.6303 116.477 94.1597H117.477ZM117.477 76.3933H116.477C116.477 76.9227 116.889 77.3603 117.418 77.3915L117.477 76.3933ZM101.912 77.3823H117.477V75.3823H101.912V77.3823ZM102.912 94.1706V76.3823H100.912V94.1706H102.912ZM117.086 93.1706H101.912V95.1706H117.086V93.1706ZM117.106 93.1706C117.1 93.1706 117.095 93.1706 117.089 93.1706L117.083 95.1706C117.091 95.1706 117.098 95.1706 117.106 95.1706V93.1706ZM117.122 93.1706C117.117 93.1706 117.111 93.1706 117.106 93.1706V95.1706C117.113 95.1706 117.121 95.1706 117.129 95.1706L117.122 93.1706ZM117.477 93.1706H117.126V95.1706H117.477V93.1706ZM116.477 94.1597V94.1706H118.477V94.1597H116.477ZM123.518 85.2765C123.518 89.6703 120.664 92.9695 117.418 93.1614L117.536 95.1579C122.132 94.8863 125.518 90.4085 125.518 85.2765H123.518ZM117.418 77.3915C120.664 77.5834 123.518 80.8827 123.518 85.2765H125.518C125.518 80.1444 122.132 75.6667 117.536 75.395L117.418 77.3915ZM116.477 76.3823V76.3933H118.477V76.3823H116.477Z",
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_ii_938_140)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 102.653,
    cy: 85.2764,
    rx: 7.41177,
    ry: 8.89412,
    fill: "#FF9D43"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 102.653,
    cy: 85.2764,
    rx: 7.41177,
    ry: 8.89412,
    stroke: "#292D32",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.653,
    cy: 85.2765,
    r: 2.96471,
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_dii_938_140)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 54.2912,
    cy: 108.438,
    r: 7.22647,
    fill: "#7F43FF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 54.2912,
    cy: 108.438,
    r: 6.22647,
    stroke: "#292D32",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_dii_938_140)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.0231 50.817C43.5885 52.4777 42.7692 55.2103 40.5483 55.7357L29.3048 58.3956C27.0839 58.921 25.1271 56.8452 25.7825 54.6591L29.1007 43.592C29.7562 41.4059 32.5323 40.7492 34.0978 42.4099L42.0231 50.817Z",
    fill: "#7F43FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.3181 54.7626L29.0746 57.4225C27.6028 57.7707 26.306 56.395 26.7404 54.9463L30.0586 43.8792C30.493 42.4305 32.3327 41.9953 33.3702 43.0958L41.2954 51.503C42.3328 52.6035 41.7899 54.4144 40.3181 54.7626Z",
    stroke: "#292D32",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_dii_938_140)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.3596 98.2119C26.0309 99.7659 25.3932 102.547 23.2117 103.217L12.1676 106.611C9.98606 107.281 7.89686 105.339 8.40703 103.114L10.9898 91.8529C11.5 89.6284 14.2269 88.7904 15.8983 90.3444L24.3596 98.2119Z",
    fill: "#FF9D43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9179 102.261L11.8739 105.655C10.4281 106.099 9.04363 104.812 9.38173 103.338L11.9645 92.0764C12.3026 90.6022 14.1097 90.0469 15.2173 91.0768L23.6786 98.9442C24.7862 99.9741 24.3636 101.817 22.9179 102.261Z",
    stroke: "#292D32",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_dii_938_140)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 83.9381,
    cy: 8.75003,
    r: 7.22647,
    fill: "#FF9D43"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 83.9381,
    cy: 8.75003,
    r: 6.22647,
    stroke: "#292D32",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_dii_938_140)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.2475 15.4002C24.5297 15.4002 25.9561 17.8708 24.815 19.8473L19.0381 29.8531C17.897 31.8296 15.0442 31.8296 13.9031 29.8531L8.12619 19.8473C6.98507 17.8708 8.41147 15.4002 10.6937 15.4002L22.2475 15.4002Z",
    fill: "#FF9D43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2475 16.4002C23.7599 16.4002 24.7052 18.0375 23.949 19.3473L18.1721 29.3531C17.4159 30.6629 15.5253 30.6629 14.7691 29.3531L8.99221 19.3473C8.236 18.0375 9.18127 16.4002 10.6937 16.4002L22.2475 16.4002Z",
    stroke: "#292D32",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M3.33521 70.0824C3.33521 68.445 4.66255 67.1177 6.29991 67.1177H28.5352C30.1726 67.1177 31.4999 68.445 31.4999 70.0824V84.9059C31.4999 86.5433 30.1726 87.8706 28.5352 87.8706H6.29991C4.66255 87.8706 3.33521 86.5433 3.33521 84.9059V70.0824Z",
    fill: "#1F2024",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter10_ii_938_140)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.85303 65.6352C1.85303 63.9979 3.18037 62.6705 4.81773 62.6705H28.906C30.5433 62.6705 31.8707 63.9979 31.8707 65.6352V80.4588C31.8707 82.0961 30.5433 83.4235 28.906 83.4235H4.81773C3.18037 83.4235 1.85303 82.0961 1.85303 80.4588V65.6352Z",
    fill: "#43CDEC"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1.85303 65.6352C1.85303 63.9979 3.18037 62.6705 4.81773 62.6705H28.906C30.5433 62.6705 31.8707 63.9979 31.8707 65.6352V80.4588C31.8707 82.0961 30.5433 83.4235 28.906 83.4235H4.81773C3.18037 83.4235 1.85303 82.0961 1.85303 80.4588V65.6352Z",
    stroke: "#292D32",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter11_i_938_140)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.9766 65.6352C22.9766 63.9979 24.3039 62.6705 25.9413 62.6705H28.906C30.5433 62.6705 31.8707 63.9979 31.8707 65.6352V80.4588C31.8707 82.0961 30.5433 83.4235 28.906 83.4235H25.9413C24.3039 83.4235 22.9766 82.0961 22.9766 80.4588V65.6352Z",
    fill: "#43CDEC"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M22.9766 65.6352C22.9766 63.9979 24.3039 62.6705 25.9413 62.6705H28.906C30.5433 62.6705 31.8707 63.9979 31.8707 65.6352V80.4588C31.8707 82.0961 30.5433 83.4235 28.906 83.4235H25.9413C24.3039 83.4235 22.9766 82.0961 22.9766 80.4588V65.6352Z",
    stroke: "#292D32",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.15283,
    y: 69.7118,
    width: 2.96471,
    height: 7.41177,
    rx: 1.48235,
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.6001,
    y: 69.7118,
    width: 2.96471,
    height: 7.41177,
    rx: 1.48235,
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.4664 70.8606C68.1088 66.0914 60.4682 65.7276 55.7439 70.8748C54.9135 71.7795 52.9721 71.6539 52.0674 70.8235C50.9631 69.8099 51.4914 66.9323 52.9357 65.5445C56.5364 62.0844 61.0814 61.1882 65.2592 61.9001C69.3799 62.6023 73.2513 64.8742 75.8143 67.9342C75.9815 68.1313 76.1086 68.3499 76.196 68.5796C76.3072 68.8716 76.354 69.1807 76.3381 69.4862C76.308 70.0656 76.0525 70.6317 75.5845 71.0423C75.3872 71.2156 75.1676 71.3477 74.9361 71.4393C74.6209 71.5641 74.2847 71.6132 73.9541 71.5888C73.401 71.548 72.8637 71.3015 72.4664 70.8606Z",
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.4452 70.8606C96.8028 66.0914 104.443 65.7276 109.168 70.8748C109.998 71.7795 111.939 71.6539 112.844 70.8235C113.949 69.8099 113.42 66.9323 111.976 65.5445C108.375 62.0844 103.83 61.1882 99.6524 61.9001C95.5317 62.6023 91.6604 64.8742 89.0973 67.9342C88.9301 68.1313 88.803 68.3499 88.7156 68.5796C88.6044 68.8716 88.5576 69.1807 88.5735 69.4862C88.6036 70.0656 88.8591 70.6317 89.3271 71.0423C89.5244 71.2156 89.7441 71.3477 89.9755 71.4393C90.2908 71.5641 90.6269 71.6132 90.9575 71.5888C91.5106 71.548 92.048 71.3015 92.4452 70.8606Z",
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.9705 90.3518C81.1585 88.6118 81.1587 83.4235 75.9705 81.9412",
    stroke: "#292D32",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.9705 98.8754C81.1585 97.1353 81.1587 91.9471 75.9705 90.4647",
    stroke: "#292D32",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter12_dii_938_140)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.524 22.9825C117.196 24.5366 116.558 27.3172 114.376 27.9876L103.332 31.3816C101.151 32.052 99.0617 30.1094 99.5718 27.8849L102.155 16.6235C102.665 14.399 105.392 13.561 107.063 15.1151L115.524 22.9825Z",
    fill: "#7F43FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.843 23.7148C115.951 24.7447 115.528 26.5874 114.083 27.0317L103.039 30.4257C101.593 30.87 100.208 29.5826 100.547 28.1085L103.129 16.847C103.467 15.3729 105.275 14.8175 106.382 15.8474L114.843 23.7148Z",
    stroke: "#292D32",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter13_dii_938_140)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 118.774,
    cy: 52.1088,
    r: 7.22647,
    fill: "#FF9D43"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 118.774,
    cy: 52.1088,
    r: 6.22647,
    stroke: "#292D32",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_938_140",
    x: 2.33521,
    y: 32.3942,
    width: 90.9412,
    height: 79.0824,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -16
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_938_140"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 16
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_938_140",
    result: "effect2_innerShadow_938_140"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_938_140",
    x: 39.394,
    y: 32.3942,
    width: 85.0117,
    height: 79.0824,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -24,
    dy: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_938_140"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_ii_938_140",
    x: 77.9353,
    y: 83.9406,
    width: 32.0176,
    height: 11.23,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2.96471,
    dy: -2.96471
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_938_140"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -2.96471,
    dy: 4.44706
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_938_140",
    result: "effect2_innerShadow_938_140"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_ii_938_140",
    x: 100.912,
    y: 75.3823,
    width: 24.6057,
    height: 19.7882,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2.96471,
    dy: -2.96471
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_938_140"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -3.70588,
    dy: 4.44706
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_938_140",
    result: "effect2_innerShadow_938_140"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_ii_938_140",
    x: 94.2412,
    y: 75.3823,
    width: 16.8235,
    height: 19.7882,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2.96471,
    dy: -2.96471
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_938_140"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -2.96471,
    dy: 4.44706
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_938_140",
    result: "effect2_innerShadow_938_140"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_dii_938_140",
    x: 45.5823,
    y: 101.212,
    width: 15.9352,
    height: 15.9354,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1.48235,
    dy: 1.48235
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.121569 0 0 0 0 0.12549 0 0 0 0 0.141176 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_938_140"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_938_140",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2.96471,
    dy: -2.96471
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_938_140"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -2.96471,
    dy: 4.44706
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_938_140",
    result: "effect3_innerShadow_938_140"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_dii_938_140",
    x: 24.1717,
    y: 41.4773,
    width: 18.6611,
    height: 18.4831,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1.48235,
    dy: 1.48235
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.121569 0 0 0 0 0.12549 0 0 0 0 0.141176 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_938_140"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_938_140",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2.96471,
    dy: -2.96471
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_938_140"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -2.96471,
    dy: 4.44706
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_938_140",
    result: "effect3_innerShadow_938_140"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_dii_938_140",
    x: 6.84699,
    y: 89.5486,
    width: 18.4599,
    height: 18.6791,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1.48235,
    dy: 1.48235
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.121569 0 0 0 0 0.12549 0 0 0 0 0.141176 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_938_140"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_938_140",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2.96471,
    dy: -2.96471
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_938_140"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -2.96471,
    dy: 4.44706
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_938_140",
    result: "effect3_innerShadow_938_140"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_dii_938_140",
    x: 75.2293,
    y: 1.52356,
    width: 15.9352,
    height: 15.9354,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1.48235,
    dy: 1.48235
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.121569 0 0 0 0 0.12549 0 0 0 0 0.141176 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_938_140"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_938_140",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2.96471,
    dy: -2.96471
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_938_140"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -2.96471,
    dy: 4.44706
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_938_140",
    result: "effect3_innerShadow_938_140"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_dii_938_140",
    x: 6.24226,
    y: 15.4001,
    width: 18.9743,
    height: 17.4177,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1.48235,
    dy: 1.48235
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.121569 0 0 0 0 0.12549 0 0 0 0 0.141176 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_938_140"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_938_140",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2.96471,
    dy: -2.96471
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_938_140"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -2.96471,
    dy: 4.44706
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_938_140",
    result: "effect3_innerShadow_938_140"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_ii_938_140",
    x: 0.853027,
    y: 61.6705,
    width: 32.0176,
    height: 22.7529,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -16
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_938_140"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 16
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_938_140",
    result: "effect2_innerShadow_938_140"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11_i_938_140",
    x: 21.9766,
    y: 61.6705,
    width: 10.894,
    height: 22.7529,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -24,
    dy: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_938_140"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter12_dii_938_140",
    x: 98.0118,
    y: 14.3192,
    width: 18.4599,
    height: 18.6791,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1.48235,
    dy: 1.48235
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.121569 0 0 0 0 0.12549 0 0 0 0 0.141176 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_938_140"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_938_140",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2.96471,
    dy: -2.96471
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_938_140"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -2.96471,
    dy: 4.44706
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_938_140",
    result: "effect3_innerShadow_938_140"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter13_dii_938_140",
    x: 110.065,
    y: 44.8823,
    width: 15.9352,
    height: 15.9352,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1.48235,
    dy: 1.48235
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.121569 0 0 0 0 0.12549 0 0 0 0 0.141176 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_938_140"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_938_140",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2.96471,
    dy: -2.96471
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_938_140"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -2.96471,
    dy: 4.44706
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_938_140",
    result: "effect3_innerShadow_938_140"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_938_140"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 129.706,
    height: 117.476,
    fill: "white",
    transform: "translate(-1.85303 0.411743)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoolBlueFrame);
export default __webpack_public_path__ + "static/media/cool_blue_frame.c0bdb512723459431e420e530d0dbb7e.svg";
export { ForwardRef as ReactComponent };